
export const PAGE_SIZE = 10
export const CUSTOMER_PAGE_SIZE = 50

//同じ名前の変数が.py側にもあるので、値を変更する場合は同時に変更すること！
export const MAX_OPERATION_CUSTOMER_SIZE = 5000
